// Default de branding por instância.
//
// Precedência da URL da empresa exibida ao usuário:
//   1. Personalizations.url (banco, runtime)  -> override por instância, já consumido nas telas
//   2. REACT_APP_COMPANY_URL (.env, build)     -> default por instância sem tocar código
//   3. fallback abaixo                         -> usado só se 1 e 2 estiverem vazios
//
// Padronização: o valor Sabe-específico fica em UM único lugar. Uma instância nova
// define REACT_APP_COMPANY_URL no .env do frontend; nada de editar telas.
export const DEFAULT_COMPANY_URL =
  process.env.REACT_APP_COMPANY_URL || "https://sabesistemas.com.br";
